import toast, { Toaster } from 'react-hot-toast';
export default function toastAlert( type,message ) {
    if (type === 'success') {
        toast(message,
            {
                
            duration: 3000,
              icon: '✔️',
              style: {
                borderRadius: '10px',
                background: 'rgb(46, 184, 53)',
                fontWeight:700,
                letterSpacing:'1px',
                color: '#fff',
              },
            }
          );
        }
        if (type === 'error') {
            toast(message,
                {
                  icon: '❌',
                  style: {
                    borderRadius: '10px',
                    fontWeight:700,
                    letterSpacing:'1px',
                    background: '#ed5454',
                    color: '#fff',
                  },
                }
              );
        }
        if (type === 'info') {
          toast(message,
              {
                icon: 'ℹ',
                style: {
                  borderRadius: '10px',
                  fontWeight:700,
                  letterSpacing:'1px',
                  background: 'blue',
                  color: '#fff',
                },
              }
            );
      }
     
        if (type === 'loading') {
          toast(message,
              {
                // duration: 3000,
                style: {
                  borderRadius: '10px',
                  fontWeight:700,
                  letterSpacing:'1px',
                  background: 'orange',
                  color: '#fff',
                },
              }
            );
      }
   
    return (
        <div>
        <Toaster
            position="top-center"
        />
    </div>
    )
}